import { useEffect } from 'react'
import { supabase } from './lib/supabaseClient'
import { useNavigate } from 'react-router-dom'

function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      const { data: { session }, error } = await supabase.auth.getSession()
      
      if (error) {
        console.error('Auth error:', error)
        navigate('/login?error=auth_failed')
        return
      }
      
      if (session) {
        // Fetch user data from your users table
        const { data: userData } = await supabase
          .from('users')
          .select('role, company_id, onboarding_completed')
          .eq('id', session.user.id)
          .maybeSingle()
        
        console.log('AuthCallback - User data:', userData)
        
        // If user has a company and role, go to leadership
        if (userData?.company_id && userData?.role === 'leadership') {
          navigate('/leadership')
        } 
        // If user has no company, go to onboarding
        else if (!userData?.company_id) {
          navigate('/onboarding')
        }
        // Otherwise go to role-based portal
        else if (userData?.role) {
          navigate(`/${userData.role}`)
        }
        else {
          navigate('/')
        }
      } else {
        navigate('/login')
      }
    }
    
    handleCallback()
  }, [navigate])

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f8fafc'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏢</div>
        <h2>Verifying your email...</h2>
        <p>Please wait while we confirm your account.</p>
      </div>
    </div>
  )
}

export default AuthCallback
